var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextInput } from "./text-input.component";
import { ConsentDetails } from "./consent-details.component";
import { regex } from "@/constants/regex.constant";
export function UserDetailsForm() {
    return (_jsxs("div", __assign({ className: "flex flex-col gap-3 items-center w-full max-w-[80%]" }, { children: [_jsxs("div", __assign({ className: "grid md:grid-cols-2 gap-3 pt-5 lg:pt-10 w-full" }, { children: [_jsx(TextInput, { controlProps: {
                            name: 'first-name',
                            rules: {
                                required: 'First name is required',
                                minLength: {
                                    value: 2,
                                    message: 'First name must be at least 2 characters',
                                },
                                maxLength: {
                                    value: 26,
                                    message: 'First name must be less than 26 characters',
                                },
                                pattern: {
                                    value: regex.personName,
                                    message: 'First name should be valid (e.g. John)',
                                },
                            },
                        }, label: "First name *" }), _jsx(TextInput, { controlProps: {
                            name: 'last-name',
                            rules: {
                                required: 'Last name is required',
                                minLength: {
                                    value: 2,
                                    message: 'Last name must be at least 2 characters',
                                },
                                maxLength: {
                                    value: 26,
                                    message: 'Last name must be less than 26 characters',
                                },
                                pattern: {
                                    value: regex.personName,
                                    message: 'Last name should be valid (e.g. Doe)',
                                },
                            },
                        }, label: "Last name *" })] })), _jsx(TextInput, { controlProps: {
                    name: 'email',
                    rules: {
                        required: 'Email is required',
                        pattern: {
                            value: regex.email,
                            message: 'Invalid email address (e.g. johndoe@email.com)',
                        },
                    },
                }, label: "Email *", className: "w-full" }), _jsx(ConsentDetails, {})] })));
}
